// const PROXY    = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
// const API      = "https://api.kucoin.com";
// const WS_TOKEN = `${API}/api/v1/bullet-public`;

// const log = (...a) => console.log("[kucoinSpot]", ...a);

// const toMs = (t) => {
//   const n = Number(t);
//   return n > 1e12 ? n : n * 1000; // авто-детект: сек → мс, мс оставляем
// };

// const toBar = (t, o, h, l, c) => ({
//   time: toMs(t),
//   open: Number(o),
//   high: Number(h),
//   low:  Number(l),
//   close: Number(c),
// });

// function mapIntervalToKucoin(tf) {
//   const m = {
//     "1m":"1min","3m":"3min","5m":"5min","15m":"15min","30m":"30min",
//     "1h":"1hour","2h":"2hour","4h":"4hour","6h":"6hour","8h":"8hour","12h":"12hour",
//     "1d":"1day","1w":"1week","1M":"1month","30d":"1month",
//   };
//   return m[tf] || "1min";
// }

// function normSpotSymbol(sym) {
//   return String(sym).replace(/_/g, "-").toUpperCase(); // ETH_USDT -> ETH-USDT
// }

// // ---------- REST ----------
// export async function kucoinSpotFetchHistory({ symbol, interval="1m", limit=300, startAt, endAt }) {
//   const spotSymbol = normSpotSymbol(symbol);
//   const type = mapIntervalToKucoin(interval);

//   const qs = new URLSearchParams();
//   qs.set("symbol", spotSymbol);
//   qs.set("type", type);
//   if (startAt) qs.set("startAt", String(Math.floor(Number(startAt)/1000)));
//   if (endAt)   qs.set("endAt",   String(Math.floor(Number(endAt)/1000)));

//   const url = `${PROXY}/${API}/api/v1/market/candles?${qs.toString()}`;
//   log("REST fetch", { symbol: spotSymbol, interval, type, url });

//   const r = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
//   if (!r.ok) throw new Error(`REST HTTP ${r.status}`);
//   const json = await r.json();
//   const rows = Array.isArray(json?.data) ? json.data : [];

//   // KuCoin отдаёт от новых к старым → разворачиваем
//   const out = rows.slice().reverse().map(a => {
//     // a = [tsSec, open, close, high, low, vol, amount]
//     const t = a?.[0], o = a?.[1], c = a?.[2], h = a?.[3], l = a?.[4];
//     if ([t,o,h,l,c].every(v => Number.isFinite(Number(v)))) {
//       return toBar(t, o, h, l, c);
//     }
//     return null;
//   }).filter(Boolean).slice(-limit);

//   log("REST done", { symbol: spotSymbol, interval, type, inCount: rows.length, outCount: out.length });
//   return out;
// }

// // ---------- WS ----------
// async function getSpotWsEndpoint() {
//   const url = `${PROXY}/${WS_TOKEN}`;
//   const r = await fetch(url, { method: "POST", headers: { 'ngrok-skip-browser-warning': '1' } });
//   if (!r.ok) throw new Error(`bullet-public HTTP ${r.status}`);
//   const j = await r.json();
//   const inst = j?.data?.instanceServers?.[0];
//   const token = j?.data?.token;
//   if (!inst?.endpoint || !token) throw new Error("no endpoint/token");
//   return { endpoint: inst.endpoint, token, pingInterval: inst?.pingInterval || 20000 };
// }

// export function kucoinSpotOpenWS({ symbol, interval="1m", onCandle }) {
//   const spotSymbol = normSpotSymbol(symbol);
//   let ws, pingTimer, watchdog;
//   let welcomed = false;
//   let lastAnyMsg = 0;

//   (async () => {
//     try {
//       const { endpoint, token, pingInterval } = await getSpotWsEndpoint();
//       const type  = mapIntervalToKucoin(interval);
//       const topic = `/market/candles:${spotSymbol}_${type}`;
//       const wsUrl = `${endpoint}?token=${encodeURIComponent(token)}&connectId=${Date.now()}`;

//       ws = new WebSocket(wsUrl);
//       log("WS open ->", { topic, wsUrl });

//       const sendSub = () => {
//         const sub = { id: Date.now(), type: "subscribe", topic, privateChannel: false, response: true };
//         try { ws?.send(JSON.stringify(sub)); log("→ SUB", sub); } catch {}
//       };

//       ws.onopen = () => {
//         pingTimer = setInterval(() => {
//           try { ws?.send(JSON.stringify({ id: Date.now(), type: "ping" })); } catch {}
//         }, Math.max(5000, pingInterval || 20000));
//         watchdog = setInterval(() => {
//           if (!welcomed) return;
//           if (Date.now() - lastAnyMsg > 2000) sendSub();
//         }, 1000);
//       };

//       ws.onmessage = (ev) => {
//         lastAnyMsg = Date.now();
//         let msg; try { msg = JSON.parse(ev.data); } catch { return; }

//         if (msg?.type === "welcome") { welcomed = true; sendSub(); return; }
//         if (msg?.type === "pong" || msg?.type === "ack") return;

//         if (msg?.type === "message" && msg?.topic === topic && msg?.data?.candles) {
//           const k = msg.data.candles; // [ts, open, close, high, low, ...]
//           if (Array.isArray(k) && k.length >= 5) {
//             const t = k[0], o = k[1], c = k[2], h = k[3], l = k[4];
//             if ([t,o,h,l,c].every(v => Number.isFinite(Number(v)))) {
//               onCandle?.(toBar(t,o,h,l,c));
//             }
//           }
//         }
//       };

//       ws.onerror = (e) => log("WS error", e);
//       ws.onclose = () => log("WS close");
//     } catch (e) {
//       log("WS bootstrap error", e?.message || String(e));
//     }
//   })();

//   return () => {
//     try { clearInterval(pingTimer); } catch {}
//     try { clearInterval(watchdog); } catch {}
//     try { ws?.close(1000, "spot close"); } catch {}
//   };
// }
/* eslint-disable max-len */
const PROXY    = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
const API      = "https://api.kucoin.com";
const WS_TOKEN = `${API}/api/v1/bullet-public`;

const log = (...a) => console.log("[kucoinSpot]", ...a);

const toMs = (t) => {
  const n = Number(t);
  return n > 1e12 ? n : n * 1000;
};

const toBar = (t, o, h, l, c) => ({
  time: toMs(t),
  open: Number(o),
  high: Number(h),
  low:  Number(l),
  close: Number(c),
});

function mapIntervalToKucoin(tf) {
  const m = {
    "1m":"1min","3m":"3min","5m":"5min","15m":"15min","30m":"30min",
    "1h":"1hour","2h":"2hour","4h":"4hour","6h":"6hour","8h":"8hour","12h":"12hour",
    "1d":"1day","1w":"1week","1M":"1month","30d":"1month",
  };
  return m[tf] || "1min";
}

function normSpotSymbol(sym) {
  return String(sym).replace(/_/g, "-").toUpperCase(); // ETH_USDT -> ETH-USDT
}

/** Жёстко нормализуем endpoint к официальным хостам KuCoin (защита от прокси-подмены) */
function normalizeKucoinSpotEndpoint(endpoint) {
  try {
    const u = new URL(endpoint);
    // если это не *.kucoin.com — подменяем на официальный спот-хост
    if (!u.hostname.endsWith("kucoin.com")) {
      u.hostname = "ws-api-spot.kucoin.com";
      u.protocol = "wss:";
    }
    // иногда endpoint приходит без trailing slash — норм ок
    return u.toString();
  } catch {
    // если совсем криво — fallback
    return "wss://ws-api-spot.kucoin.com";
  }
}

// ---------- REST ----------
export async function kucoinSpotFetchHistory({ symbol, interval="1m", limit=300, startAt, endAt }) {
  const spotSymbol = normSpotSymbol(symbol);
  const type = mapIntervalToKucoin(interval);

  const qs = new URLSearchParams();
  qs.set("symbol", spotSymbol);
  qs.set("type", type);
  if (startAt) qs.set("startAt", String(Math.floor(Number(startAt)/1000)));
  if (endAt)   qs.set("endAt",   String(Math.floor(Number(endAt)/1000)));

  const url = `${PROXY}/${API}/api/v1/market/candles?${qs.toString()}`;
  log("REST fetch", { symbol: spotSymbol, interval, type, url });

  const r = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
  if (!r.ok) throw new Error(`REST HTTP ${r.status}`);
  const json = await r.json();
  const rows = Array.isArray(json?.data) ? json.data : [];

  // от новых к старым → разворачиваем
  const out = rows.slice().reverse().map(a => {
    // a = [tsSec, open, close, high, low, vol, amount]
    const t = a?.[0], o = a?.[1], c = a?.[2], h = a?.[3], l = a?.[4];
    if ([t,o,h,l,c].every(v => Number.isFinite(Number(v)))) {
      return toBar(t, o, h, l, c);
    }
    return null;
  }).filter(Boolean).slice(-limit);

  log("REST done", { symbol: spotSymbol, interval, type, inCount: rows.length, outCount: out.length });
  return out;
}

// ---------- WS (kline) ----------
async function getSpotWsConfig() {
  const url = `${PROXY}/${WS_TOKEN}`;
  const r = await fetch(url, { method: "POST", headers: { 'ngrok-skip-browser-warning': '1' } });
  if (!r.ok) throw new Error(`bullet-public HTTP ${r.status}`);
  const j = await r.json();
  const inst = j?.data?.instanceServers?.[0];
  const token = j?.data?.token;
  if (!inst?.endpoint || !token) throw new Error("no endpoint/token");
  const endpoint = normalizeKucoinSpotEndpoint(inst.endpoint);
  const pingInterval = Number(inst?.pingInterval || 20000);
  return { endpoint, token, pingInterval };
}

export function kucoinSpotOpenWS({ symbol, interval="1m", onCandle }) {
  const spotSymbol = normSpotSymbol(symbol);
  let ws, pingTimer, welcomed = false;

  (async () => {
    try {
      const { endpoint, token, pingInterval } = await getSpotWsConfig();
      const type  = mapIntervalToKucoin(interval);
      const topic = `/market/candles:${spotSymbol}_${type}`;

      // Собираем WS URL строго через URL API, чтобы не потерять '?'
      const u = new URL(endpoint);
      u.searchParams.set("token", token);
      u.searchParams.set("connectId", String(Date.now()));
      const wsUrl = u.toString();

      ws = new WebSocket(wsUrl);
      log("WS open ->", { topic, wsUrl });

      const sendSub = () => {
        const sub = { id: Date.now(), type: "subscribe", topic, privateChannel: false, response: true };
        try { ws?.send(JSON.stringify(sub)); log("→ SUB", sub); } catch {}
      };

      ws.onopen = () => {
        pingTimer = setInterval(() => {
          try { ws?.send(JSON.stringify({ id: Date.now(), type: "ping" })); } catch {}
        }, Math.max(5000, pingInterval - 1000));
      };

      ws.onmessage = (ev) => {
        let msg; try { msg = JSON.parse(ev.data); } catch { return; }

        if (msg?.type === "welcome") { welcomed = true; sendSub(); return; }
        if (msg?.type === "pong" || msg?.type === "ack") return;

        if (msg?.type === "message" && msg?.topic === topic && msg?.data?.candles) {
          // candles = [tsSec, open, close, high, low, vol, amount]
          const k = msg.data.candles;
          if (Array.isArray(k) && k.length >= 5) {
            const t = k[0], o = k[1], c = k[2], h = k[3], l = k[4];
            if ([t,o,h,l,c].every(v => Number.isFinite(Number(v)))) {
              onCandle?.(toBar(t,o,h,l,c));
            }
          }
        }
      };

      ws.onerror = (e) => log("WS error", e);
      ws.onclose = () => log("WS close");
    } catch (e) {
      log("WS bootstrap error", e?.message || String(e));
    }
  })();

  return () => {
    try { clearInterval(pingTimer); } catch {}
    try { ws?.close(1000, "spot close"); } catch {}
  };
}
